import { getRelativeImagePath } from "util/helper/getRelativeImagePath";

export const PaymentMethods = [{
  id: "sezzle",
  imgLogo: `${process.env.NEXT_PUBLIC_ROOT_URL}/images/third-party-logos/sezzle-logo.png`,
  tagLine: "sezzle_tagline",
  imgProcess: `${process.env.NEXT_PUBLIC_ROOT_URL}/cms/pubicImages/images/SezzleGraphic.webp`,
  processTagLine: "sezzle_process_tagline",
  processSubHeading: "sezzle_process_sub_heading",
  themeColor: "#f44336",
  button1text: "sezzle_apply_button",
  button1Url: "https://dashboard.sezzle.com/customer/login",
  button2text: "MANAGE YOUR ACCOUNT",
  button2Url: "https://dashboard.sezzle.com/customer/login",
  customerCareContact: "+1 (888) 540-1867",
},
{
  id: "flexiti",
  imgLogo: getRelativeImagePath("/images/public/third-party/flexiti-logo.png"),
  tagLine: "flexiti_tagline",
  imgProcess: getRelativeImagePath("/cms/pubicImages/images/FlexitiCardImage.webp"),
  processTagLine: "flexiti_process_tagline",
  processSubHeading: "flexiti_process_sub_heading",
  themeColor: "#026c79",
  button1text: "flexiti_apply_button",
  button1Url: "https://www.flexiti.com/how-it-works",
  button2text: "MANAGE YOUR ACCOUNT",
  button2Url: "https://www.flexiti.com/how-it-works",
  customerCareContact: "1-877-259-3745",
},
];

// {
//   imgLogo: "flexiti-logo.png",
//   tagLine: "Get instant financing with FlexitiCard and finance your purchases online at PartsAvatar.ca",
//   imgProcess: "flexiti-payment-division.png",
//   processTagLine: "Pay Monthly",
//   processSubHeading: "Monthly payments over 6 to 24 months for larger purchases.",
//   themeColor: "#026c79",
//   button1text: "APPLY NOW FOR INSTANT CREDIT",
//   button2text: "MANAGE YOUR ACCOUNT",
//   customerCareContact: "1-877-259-3745",
//   faq: [
//     {
//       heading: "How do I use Flexiti ?",
//       content: <div>How do I use Flexiti ?</div>,
//     },
//
//     {
//       heading: "How much I can spend with Flexiti ?",
//       content: <div>How much I can spend with Flexiti</div>,
//     },
//   ],
// },
